import type { NormalChatMessage } from '../types/centrifuge/public-message/normalChatMessageTypes';

/**
 * 텍스트를 지정된 길이로 자르고 말줄임표(...)를 추가합니다.
 * 타입 안전성을 보장하며, unknown 타입도 처리할 수 있습니다.
 *
 * @param text - 자를 텍스트 (string 또는 unknown 타입)
 * @param maxLength - 최대 길이 (기본값: 100)
 * @returns 잘린 텍스트 또는 원본 텍스트
 */
export const truncateText = (text: unknown, maxLength: number = 100): string => {
  const safeText = typeof text === 'string' ? text : String(text ?? '');

  if (safeText.length <= maxLength) return safeText;
  return `${safeText.slice(0, maxLength)}...`;
};

/**
 * 채팅 메시지의 타입에 따라 텍스트 길이를 제한합니다.
 * - BJ, 매니저: 최대 600자
 * - 일반 유저: 최대 100자
 */
export const truncateNormalChatMessage = (item: NormalChatMessage) => {
  const { data } = item;

  // 매니저, BJ 최대 600자까지 노출
  if (data.type === 'manager' || data.type === 'bj') {
    return truncateText(data.message || '', 600);
  }
  // 일반유저 최대 100자까지 노출
  return truncateText(data.message || '', 100);
};

export const truncateFanzaNormalChatMessage = (data: NormalChatMessage['data']) => {
  // 매니저, BJ, 서포터 최대 600자까지 노출
  // BJ 일 경우 일본어 메시지 노출
  if (data.type === 'bj') {
    return truncateText(data.translate?.ja || data.message || '', 600);
  }
  if (data.type === 'manager' || data.type === 'support') {
    return truncateText(data.message || '', 600);
  }
  // 일반유저 최대 100자까지 노출
  return truncateText(data.message || '', 100);
};
